module.exports = __webpack_public_path__ + "img/thumbnail_LittlePenguin_f_normal.c4bee79a.png";